export default __webpack_public_path__ + "static/media/452.92c8bbe5.png";